import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ImageOff } from "lucide-react";

export default function AuthImage({ path, alt, className }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let url;
    let mounted = true;
    api
      .get(path, { responseType: "blob" })
      .then((r) => {
        if (!mounted) return;
        url = URL.createObjectURL(r.data);
        setSrc(url);
      })
      .catch(() => mounted && setErr(true));
    return () => {
      mounted = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (err) return <div className={`flex items-center justify-center bg-slate-100 text-slate-300 ${className}`}><ImageOff className="h-6 w-6" /></div>;
  if (!src) return <div className={`bg-slate-100 animate-pulse ${className}`} />;
  return <img src={src} alt={alt} className={className} />;
}
